module.exports = __webpack_public_path__ + "static/media/PK_Logo_LOCK_Horiz_ColorWhite.c7968ac2.png";